export default "__VITE_ASSET__7884195c__"